import { BaseCredentialApplicationReportFields } from './base-credential-application-report.fields';

export const PersonCredentialApplicationReportFields = {
  ...BaseCredentialApplicationReportFields,
  personId: 'personId',
  personCredentialId: 'personCredentialId',
  imageId: 'imageId',
  email: 'email',
  firstName: 'firstName',
  middleName: 'middleName',
  lastName: 'lastName',
  fullName: 'fullName',
  suffix: 'suffix',
  scenarios: 'scenarios'
} as const;

export type PersonCredentialApplicationReportFields =
  (typeof PersonCredentialApplicationReportFields)[keyof typeof PersonCredentialApplicationReportFields];
